<template>
  <!-- 待审 -->
  <div class="main">
    <template v-if="!showflowDetailBoolean">
      <!-- 标题行 -->
      <div class="titleRow">
        <div class="title">
          <el-divider direction="vertical"></el-divider>
          <span>待审</span>
          <el-radio-group v-model="approvalType" size="mini">
            <el-radio-button label="0">流程</el-radio-button>
            <el-radio-button label="1">计划</el-radio-button>
          </el-radio-group>
        </div>

        <div class="options">
          <span :class="{'spanDisabled': !currentPrjId}" @click="enterProjectWait">
            更多<i class="el-icon-d-arrow-right"></i>
          </span>
        </div>
      </div>

      <!-- 展示区 -->
      <div class="showArea">
        <!-- 暂无待审 -->
        <div v-if="approvalList.length == 0" class="notApprove">
          <el-image style="width: 280px; height: 220px" :src="notApprove" fit="contain"></el-image>
        </div>

        <!-- 有待审 -->
        <template v-if="approvalList.length">
          <!-- 流程表格 -->
          <el-table v-if="approvalType == '0'" v-loading="loading" height="calc(100% - 38px)" :data="approvalList"
            border highlight-current-row @row-click="flowClickChange">
            <el-table-column label="标题" prop="title" align="center" width="120px" show-overflow-tooltip />
            <el-table-column label="流程类型" prop="flowType" align="center" show-overflow-tooltip />
            <el-table-column label="申请时间" prop="flowInstanceStartTime" align="center" show-overflow-tooltip />
            <el-table-column label="申请人" prop="flowInstanceOwnerName" align="center" show-overflow-tooltip />
          </el-table>
          <!-- 计划表格 -->
          <el-table v-if="approvalType == '1'" v-loading="loading" height="calc(100% - 40px)" :data="approvalList"
            border highlight-current-row @row-click="taskClickChange">
            <el-table-column label="标题" prop="taskName" align="center" width="120px" show-overflow-tooltip />
            <el-table-column label="进度" prop="taskProgress" align="center" show-overflow-tooltip>
              <template #default="{ row }">
                {{ row.taskProgress }}%
              </template>
            </el-table-column>
            <el-table-column label="计划类型" prop="taskTypeName" align="center" show-overflow-tooltip />
            <el-table-column label="计划结束时间" prop="endDate" align="center" show-overflow-tooltip />
          </el-table>

          <!-- 分页 -->
          <el-pagination v-if="page.total > 0" background layout="prev, pager, next" :pager-count="5"
            :current-page.sync="page.pageNo" :page-size="page.pageSize" :total="page.total"
            @current-change="getApprovalList">
          </el-pagination>
        </template>
      </div>
    </template>

    <!-- 审批、查看、编辑等依赖这个组件，必需带上 -->
    <!-- <flowDialogSummary ref="flowDialogSummary" mode="edit" :view="viewMode" @updateTable="updateTable" /> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import workProjectBoardService from "@/CommonDP/service/workProjectBoard-service";
// import flowDialogSummary from "@/CommonDP/components/processComponents/flow/flowDialogSummary.vue";
import { openFlow } from "@/CommonDP/components/processComponents/flowNew/index.js";
export default {
  props: ["currentPrjId"],
  data() {
    return {
      notApprove: require("@/CommonDP/assets/workProjectBoard/notApprove.png"), // 暂无待审
      approvalType: "0", // 审批类型
      approvalList: [], // 待审列表
      page: {
        pageSize: 20,
        pageNo: 1,
        total: 0
      }, // 分页
      loading: false,
      customizeComponent: "",
      showflowDetailBoolean: false,
      viewMode: 1 // 新增0 审批1 查看2
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  watch: {
    currentPrjId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.page.pageNo = 1;
          this.approvalList = [];
          this.getApprovalList();
        }
      }
    },
    approvalType() {
      this.page.pageNo = 1;
      this.getApprovalList();
    }
  },
  mounted() {},
  methods: {
    updateTable() {

    },
    async reback(val) {
      if (val === "reback") {
        this.showflowDetailBoolean = false;
        this.getApprovalList();
      }
    },

    // 获得待审列表
    async getApprovalList() {
      const params = {
        enterpriseId: this.enterpriseId,
        prjId: this.currentPrjId
      };
      const { pageSize, pageNo } = this.page;
      this.loading = true;
      if (this.approvalType === "0") {
        // 流程
        try {
          const res = await workProjectBoardService.getApproveFlows(params, pageSize, pageNo);
          this.approvalList = res.data;
          this.page.total = res.totalCount;
        } finally {
          this.loading = false;
        }
      }
      if (this.approvalType === "1") {
        // 计划
        try {
          const res = await workProjectBoardService.getApproveTasks(params, pageSize, pageNo);
          this.approvalList = res.data;
          this.page.total = res.totalCount;
        } finally {
          this.loading = false;
        }
      }
    },

    // 跳转流程
    async flowClickChange(row) {
      const { currentVersionId = "", flowInstanceId = "", flowKey, businessId = "", startMode } = row;
      const data = { currentVersionId, flowInstanceId, flowKey, approveType: "edit", businessId, enterpriseId: this.enterpriseId, isProject: false };
      // 新窗口打开
      if (startMode === "stdNew") {
        const routeUrl = this.$router.resolve({ path: "/examine-new", query: data });
        window.open(routeUrl.href, "_blank");
      } else {
        try {
          await openFlow(data);
        } catch (error) {
          console.log(error);
        }
      }
      this.getApprovalList();
      // if (row.startMode === 'stdNew') {
      //   const query = {
      //     queryMode: 'edit',
      //     currentVersionId: row.flowVersion,
      //     flowInstanceId: row.flowInstanceId,
      //     queryView: 1
      //   };
      //   const routeUrl = this.$router.resolve({ path: "/examine-approve-detail", query });
      //   window.open(routeUrl.href, "_blank");
      // } else {
      //   this.$refs.flowDialogSummary.openEditDialog(row);
      // }
    },

    // 跳转计划
    taskClickChange(val) {
      this.$emit("enterProjectFront");
      this.$router.push({
        // path: "/mainMg/projectMg/progress/checkAddEdit",
        path: "/project-taskDetail",
        query: {
          showType: "check",
          task: val.taskId || "0"
        }
      });
    },

    // 更多,跳转项目
    enterProjectWait() {
      this.$emit("enterProjectFront");
      if (this.approvalType === "0") {
        // this.$router.push("/mainMg/processManagement/myApplication"); // 项目-我的审批
        this.$router.push("/project-approval");
      }
      if (this.approvalType === "1") {
        // this.$router.push("/mainMg/projectMg/progress/list"); // 项目-计划
        this.$router.push("/project-taskList");
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .titleRow {
    width: 100%;
    border-bottom: 1px solid #e5e8f1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    .title {
      display: flex;
      align-items: center;

      .el-divider {
        width: 3px;
        height: 15px;
        margin-left: 0;
        background: var(--theme-color);
      }

      span {
        font-family: "PingFang SC";
        font-weight: 700;
        font-size: 16px;
        color: var(--key-color);
      }

      .el-radio-group {
        left: calc(60px + var(--big-space));
        position: absolute;

        /deep/ .el-radio-button__inner {
          font-size: 14px;
        }
      }
    }

    .options {
      span {
        font-family: "PingFang SC";
        font-weight: 400;
        font-size: 14px;
        color: var(--common-color);
        cursor: pointer;

        display: flex;
        align-items: center;
      }
      span:hover {
        color: var(--theme-color);
      }

      .spanDisabled {
        pointer-events: none;
      }
    }
  }

  .showArea {
    width: 100%;
    height: 1px;
    flex-grow: 1;
    padding: var(--middle-space) var(--big-space);
    overflow: hidden;

    .notApprove {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .el-pagination {
      float: right;
      padding-top: var(--small-space);
    }
  }
}

/deep/ .el-table__row {
  cursor: pointer;
}
</style>
